module.exports = __webpack_public_path__ + "img/login02.6fc36f2b.png";